/**
 * Capitalize the first letter of a string
 * 
 * @param value - The string to capitalize
 * @returns The capitalized string
 */
export const capitalizeFirstLetter = (value: string): string => {
    return value.charAt(0).toUpperCase() + value.slice(1)
}


/**
 * Standardize a URL by adding https:// if it's not present
 * 
 * @param link - The URL to standardize
 * @returns The standardized URL
 */
export const standardizeUrl = (link?: string | null): string | null => {
    const v = (link || "").trim();
    if (!v) return null;
    if (!/^https?:\/\//i.test(v)) return `https://${v}`;
    return v;
  };